import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from "../AuthContext";
import '../styles/TombsMap.css';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const TombsMap = () => {
    const { user /*, setUser */ } = useAuth();
    const [locations, setLocations] = useState([]);    
    const [totnumber, setTotnumber] = useState();
    const [markers, setMarkers] = useState([]); // ✅ 등록된 마커들을 저장    
    const currentOverlayRef = useRef(null); // 🔥 CustomOverlay 관리용 ref 추가

    const [searchField, setSearchField] = useState("ALL");  // 라디오 버튼에서 선택된 항목
    const [searchKeyword, setSearchKeyword] = useState("");  // 검색 키워드
    const [searchKeyword2, setSearchKeyword2] = useState("");  // 검색 키워드
    const [plist, setPlist] = useState([]);
    const [glist, setGlist] = useState([]);
    const hasRun = useRef(false);
    
    const [map, setMap] = useState(null);
      // 상태로 현재 지도 타입 관리
    const [mapType, setMapType] = useState("HYBRID"); // 기본값은 하이브리드


    const [myMarker, setMyMarker] = useState(null);
    //const myLocationIcon = "https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/markerStar.png"; // 🔵 아이콘 이미지
    const myLocationIcon = "https://bitdamstorage.blob.core.windows.net/bitdamstorage/mylocation2.png"; // 🔵 아이콘 이미지
    // 🟢 현재 위치 버튼 클릭 이벤트
    const handleCurrentLocation = () => {
        if (!map) return;

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const positionObj = new window.kakao.maps.LatLng(latitude, longitude);

                    // 기존 마커 삭제
                    if (myMarker) {
                        myMarker.setMap(null);
                    }

                    // 🔵 현재 위치 마커 추가
                    const marker = new window.kakao.maps.Marker({
                        position: positionObj,
                        image: new window.kakao.maps.MarkerImage(
                            myLocationIcon,
                            new window.kakao.maps.Size(30, 30), // 아이콘 크기 조정
                            { offset: new window.kakao.maps.Point(15, 30) }
                        ),
                        opacity: 0, // 초기 투명도 0 (안 보이게 시작)
                    });

                    marker.setMap(map);
                    setMyMarker(marker);

                    // 지도 중심을 현재 위치로 이동
                    map.setCenter(positionObj);

                    // ✅ 0.2초마다 opacity 증가 (1초 동안 부드럽게 나타남)
                    let opacity = 0;
                    const fadeIn = setInterval(() => {
                        opacity += 0.1;
                        marker.setOpacity(opacity);
                        if (opacity >= 1) clearInterval(fadeIn); // 완료 시 종료
                    }, 100);

                    // 🔵 좌표 -> 주소 변환
                    const geocoder = new window.kakao.maps.services.Geocoder();
                    geocoder.coord2Address(longitude, latitude, (result, status) => {
                        if (status === window.kakao.maps.services.Status.OK) {
                            const roadAddress = result[0]?.road_address?.address_name || "";
                            const jibunAddress = result[0]?.address?.address_name || "";
                            const fullAddress = roadAddress || jibunAddress || "주소를 찾을 수 없습니다.";

                            // 🔵 CustomOverlay 생성 (초기에는 지도에 추가 X)
                            const overlay = new window.kakao.maps.CustomOverlay({
                                position: marker.getPosition(),
                                content: `
                            <div class="custom-infowindow">
                                <div><span class="field-name">📍 위도:</span><span class="field-value">${latitude.toFixed(6)}</span></div>
                                <div><span class="field-name">📍 경도:</span><span class="field-value">${longitude.toFixed(6)}</span></div>
                                <div><span class="field-name">🏠 주소:</span><span class="field-value">${fullAddress}</span></div>
                            </div>
                        `,
                                yAnchor: 1.5,
                                zIndex: 3,
                            });

                            // 🔵 마커 클릭 이벤트 추가 (자신을 다시 클릭하면 닫기)
                            window.kakao.maps.event.addListener(marker, "click", () => {
                                if (currentOverlayRef.current === overlay) {
                                    // 🔥 같은 마커 클릭하면 CustomOverlay 닫기
                                    overlay.setMap(null);
                                    currentOverlayRef.current = null;
                                    return;
                                }

                                // ✅ 기존 CustomOverlay 닫기
                                if (currentOverlayRef.current) {
                                    currentOverlayRef.current.setMap(null);
                                }

                                overlay.setMap(map);
                                currentOverlayRef.current = overlay;
                            });
                        }
                    });
                },
                (error) => console.error("위치 정보를 가져올 수 없습니다.", error),
                { enableHighAccuracy: true }
            );
        } else {
            console.error("Geolocation을 지원하지 않습니다.");
        }
    };


    // 🟢 현재 위치 버튼 스타일
    const buttonStyle = {
        position: "absolute",
        bottom: "50px",
        right: "10px",
        width: "30px",
        height: "30px",
        background: `url(${myLocationIcon}) no-repeat center center / cover`,
        borderRadius: "50%",
        cursor: "pointer",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    };

    const [zoomLevel, setZoomLevel] = useState(10); // 초기 줌 레벨

    const handleZoomIn = () => {  // + 버튼
        if (zoomLevel > 0) {
            setZoomLevel(zoomLevel - 1);
            map.setLevel(zoomLevel - 1); // 카카오맵 줌 조정
        }        
    };

    const handleZoomOut = () => {  // - 버튼
        if (zoomLevel < 14) {
            setZoomLevel(zoomLevel + 1);
            map.setLevel(zoomLevel + 1); // 카카오맵 줌 조정
        }
    };

    const handleSliderChange = (event) => {
        const newZoom = 14 - Number(event.target.value);
        setZoomLevel(newZoom);
        map.setLevel(newZoom); // 카카오맵 줌 조정
    };

    useEffect(() => {
        window.history.scrollRestoration = "manual"; // 이전 스크롤 위치 기억 방지
        window.scrollTo(0, 0);
    }, []); // 페이지 로드 시 실행

    useEffect(() => {
        window.onload = function () {
            setTimeout(() => {
                window.history.scrollRestoration = "manual"; // 이전 스크롤 위치 기억 방지
                window.scrollTo(0, 0);
            }, 100); // 100ms 후 실행 (브라우저마다 조정 가능)
        };
    }, []); // 페이지 로드 시 실행

     // ✅ 카카오맵 API 스크립트 로드 (한 번만 실행)
    useEffect(() => {
        if (hasRun.current) return; // 이미 실행되었으면 종료
        hasRun.current = true; // 첫 실행 후 플래그 설정
            //console.log("useEffect 1번");

        if (!document.getElementById("kakao-map-script")) {
            //console.log("1");
            const script = document.createElement("script");
            script.id = "kakao-map-script";
            script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=d7ae19a6101738fc44ac012874d79a76&libraries=services`;
            //script.async = true; // 비동기 로드
            //script.defer = true; // HTML 파싱 후 실행
            script.onload = () => {
                window.kakao.maps.load(() => {
                    //console.log("2");
                    initMap();                    
                });
            };
            
            document.body.appendChild(script);
        } else {
            // 카카오 맵 스크립트가 이미 로드된 경우
            // 이 부분은 스크립트가 완전히 로드된 후에만 initMap()을 호출해야 합니다.
            // 예시로, `window.kakao`가 정의되어 있는지 확인하는 조건을 추가합니다.
            if (window.kakao) {
                window.kakao.maps.load(() => {
                    //console.log("3");
                    initMap();
                });
            } else {
                console.error('카카오 맵 SDK가 로드되지 않았습니다.');
            }
        }

        if (user.userType === "S") {
            getPartnerCode();
            getGovernmentCode();
        }
        else if (user.userType === "P") {
            setSearchField(user.partnerCode);  // 선택된 콤보박스 값 설정     
        }
        else if (user.userType === "G") {
            getPartnerCode();
            //setSearchField(user.governmentCode);  // 선택된 콤보박스 값 설정     
        }

    }, []);

      // ✅ 지도 초기화 함수
    const initMap = () => {
        try {
            if (window.kakao && window.kakao.maps) {
                const container = document.getElementById("kmap");
                const options = {
                    center: new window.kakao.maps.LatLng(36.328185, 128.025296),
                    level: 12,
                    mapTypeId: window.kakao.maps.MapTypeId.HYBRID,
                };
                setSelectedMapType("HYBRID");
                const newMap = new window.kakao.maps.Map(container, options);
                setMap(newMap);
            } else {
                console.error("Kakao Map SDK가 제대로 로드되지 않았습니다.");
            }
        }
        catch {
            const existingScript = document.getElementById("kakao-map-script");
            if (existingScript) {
                //console.log("기존 스크립트 삭제");
                document.body.removeChild(existingScript);
            }
            //console.log("map error");
        }
    };



    // 봉안유형을 매핑하는 객체
    const enshrineTypeMap = {
        A: "무연고묘 봉안",
        B: "무연고묘 확인",
        C: "연고자 바로봉안",
        D: "연고자묘의 봉안",
        E: "연고자묘"
    };

    useEffect(() => {
        if (markers) {
            markers.forEach((marker) => marker.setMap(null));
            setMarkers([]);
            if (currentOverlayRef.current) {
                currentOverlayRef.current.setMap(null);
                currentOverlayRef.current = null;
            }
        }
        if (!map || locations.length === 0) return;

        const bounds = new window.kakao.maps.LatLngBounds();
        let singleLocation = null;
        const geocoder = new window.kakao.maps.services.Geocoder();

        const newMarkers = locations.map((data) => {
            const position = new window.kakao.maps.LatLng(data.cemeteryLatitude, data.cemeteryLongitude);

            const markerColors = {
                A: "https://bitdamstorage.blob.core.windows.net/bitdamstorage/location-blue.png",
                B: "https://bitdamstorage.blob.core.windows.net/bitdamstorage/location-red.png",
                D: "https://bitdamstorage.blob.core.windows.net/bitdamstorage/location-green.png",
                E: "https://bitdamstorage.blob.core.windows.net/bitdamstorage/location-yellow.png",
            };

            const markerImage = new window.kakao.maps.MarkerImage(
                markerColors[data.enshrineType] || markerColors.A,
                new window.kakao.maps.Size(36, 36),
                { offset: new window.kakao.maps.Point(18, 36) }
            );

            const marker = new window.kakao.maps.Marker({
                position,
                image: markerImage,
            });

            marker.setMap(map);

            if (locations.length > 1) {
                bounds.extend(position);
            } else {
                singleLocation = position;
            }

            if (map && locations.length === 1) {
                setTimeout(() => {
                    map.setCenter(position);
                    map.setLevel(2);
                }, 100);
            }

            const partnerInfo = plist.find(p => p.partnerCode === data.partnerCode);
            const partnerText = partnerInfo ? `${data.partnerCode} (${partnerInfo.partnerName})` : data.partnerCode;

            const governmentInfo = glist.find(g => g.governmentCode === data.governmentCode);
            const governmentText = governmentInfo ? `${data.governmentCode} (${governmentInfo.governmentName})` : data.governmentCode;

            const overlay = new window.kakao.maps.CustomOverlay({
                position: marker.getPosition(),
                content: `<div class="custom-infowindow">Loading address...</div>`, // 초기값
                yAnchor: 1.5,
                zIndex: 3,
            });

            window.kakao.maps.event.addListener(marker, "click", () => {
                if (currentOverlayRef.current === overlay) {
                    overlay.setMap(null);
                    currentOverlayRef.current = null;
                    return;
                }

                if (currentOverlayRef.current) {
                    currentOverlayRef.current.setMap(null);
                }

                // ✅ 마커 클릭 시 주소 가져오기
                geocoder.coord2Address(data.cemeteryLongitude, data.cemeteryLatitude, (result, status) => {
                    if (status === window.kakao.maps.services.Status.OK) {
                        const roadAddress = result[0]?.road_address?.address_name || "";
                        const jibunAddress = result[0]?.address?.address_name || "";
                        const fullAddress = roadAddress || jibunAddress || "주소를 찾을 수 없습니다.";

                        // ✅ 주소 포함하여 Overlay 업데이트
                        overlay.setContent(`
                        <div class="custom-infowindow">
                            ${data.enshrineCode ? `<div><span class="field-name">고유번호</span><span class="field-value">${data.enshrineCode}</span></div>` : ''}
                            ${data.enshrineDate ? `<div><span class="field-name">봉안일자</span><span class="field-value">${data.enshrineDate}</span></div>` : ''}
                            ${data.enshrineType ? `<div><span class="field-name">봉안유형</span><span class="field-value">${enshrineTypeMap[data.enshrineType] || data.enshrineType}</span></div>` : ''}
                            ${data.deceasedName ? `<div><span class="field-name">고인성명</span><span class="field-value">${data.deceasedName}</span></div>` : ''}
                            ${data.deceasedMemo ? `<div><span class="field-name">남기는말</span><span class="field-value">${data.deceasedMemo}</span></div>` : ''}
                            ${(user.userType === "S" || user.userType === "G") && data.partnerCode ? `<div><span class="field-name">파트너코드</span><span class="field-value">${partnerText}</span></div>` : ''}
                            ${(user.userType === "S") && data.governmentCode ? `<div><span class="field-name">관공서코드</span><span class="field-value">${governmentText}</span></div>` : ''}
                            <div><span class="field-name">주소</span><span class="field-value">${fullAddress}</span></div>
                        </div>
                    `);
                    }
                });

                overlay.setMap(map);
                currentOverlayRef.current = overlay;
            });

            return marker;
        });

        setMarkers(newMarkers);

        if (locations.length === 1 && singleLocation) {
            map.setCenter(singleLocation);
            map.setLevel(2);
        } else if (locations.length > 1) {
            map.setBounds(bounds);
        }
    }, [locations, map]);



    /*
    useEffect(() => {
        if (markers) {
            // ✅ 기존에 등록된 모든 마커 및 CustomOverlay 삭제
            markers.forEach((marker) => marker.setMap(null));
            setMarkers([]);

            if (currentOverlayRef.current) {
                currentOverlayRef.current.setMap(null);
                currentOverlayRef.current = null;
            }
        }
        if (!map || locations.length === 0) return;

        const bounds = new window.kakao.maps.LatLngBounds();
        let singleLocation = null;

        const newMarkers = locations.map((data) => {
            const position = new window.kakao.maps.LatLng(data.cemeteryLatitude, data.cemeteryLongitude);
*/
            /*
            const markerColors = {
                A: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                B: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
                D: "http://maps.google.com/mapfiles/ms/icons/orange-dot.png",
                E: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png",
            };
            */
/*
            const markerColors = {
                A: "https://bitdamstorage.blob.core.windows.net/bitdamstorage/location-blue.png",
                B: "https://bitdamstorage.blob.core.windows.net/bitdamstorage/location-red.png",
                D: "https://bitdamstorage.blob.core.windows.net/bitdamstorage/location-green.png",
                E: "https://bitdamstorage.blob.core.windows.net/bitdamstorage/location-yellow.png",
            };

            const markerImage = new window.kakao.maps.MarkerImage(
                markerColors[data.enshrineType] || markerColors.A,
                new window.kakao.maps.Size(36, 36),
                { offset: new window.kakao.maps.Point(18, 36) }
            );

            const marker = new window.kakao.maps.Marker({
                position,
                image: markerImage,
            });

            marker.setMap(map);

            // ✅ 여러 개의 마커가 있으면 bounds에 추가
            if (locations.length > 1) {
                bounds.extend(position);
            } else {
                singleLocation = position;
            }

            if (map && locations.length === 1) {
                setTimeout(() => {
                    map.setCenter(new window.kakao.maps.LatLng(locations[0].cemeteryLatitude, locations[0].cemeteryLongitude));
                    map.setLevel(2);
                }, 100);
            }


                  // ✅ partnerCode 변환 (plist 배열 검색)
            const partnerInfo = plist.find(p => p.partnerCode === data.partnerCode);
            const partnerText = partnerInfo ? `${data.partnerCode} (${partnerInfo.partnerName})` : data.partnerCode;

                   // ✅ governmentCode 변환 (glist 배열 검색)
            const governmentInfo = glist.find(g => g.governmentCode === data.governmentCode);
            const governmentText = governmentInfo ? `${data.governmentCode} (${governmentInfo.governmentName})` : data.governmentCode;



                  // ✅ CustomOverlay 생성 (초기에는 지도에 추가 X)
            const overlay = new window.kakao.maps.CustomOverlay({
                position: marker.getPosition(),
                content: `
                <div class="custom-infowindow">
                    ${data.enshrineCode ? `<div><span class="field-name">고유번호</span><span class="field-value">${data.enshrineCode}</span></div>` : ''}
                    ${data.enshrineDate ? `<div><span class="field-name">봉안일자</span><span class="field-value">${data.enshrineDate}</span></div>` : ''}
                    ${data.enshrineType ? `<div><span class="field-name">봉안유형</span><span class="field-value">${enshrineTypeMap[data.enshrineType] || data.enshrineType}</span></div>` : ''}
                    ${data.deceasedName ? `<div><span class="field-name">고인성명</span><span class="field-value">${data.deceasedName}</span></div>` : ''}
                    ${data.deceasedMemo ? `<div><span class="field-name">남기는말</span><span class="field-value">${data.deceasedMemo}</span></div>` : ''}
                    ${(user.userType === "S" || user.userType === "G") && data.partnerCode ? `<div><span class="field-name">파트너코드</span><span class="field-value">${partnerText}</span></div>` : ''}
                    ${(user.userType === "S") && data.governmentCode ? `<div><span class="field-name">관공서코드</span><span class="field-value">${governmentText}</span></div>` : ''}
                </div>
            `,
                yAnchor: 1.5,
                zIndex: 3,
            });

            // ✅ 마커 클릭 이벤트 추가 (자신을 다시 클릭하면 닫기)
            window.kakao.maps.event.addListener(marker, "click", () => {
                if (currentOverlayRef.current === overlay) {
                    // 🔥 같은 마커 클릭하면 CustomOverlay 닫기
                    overlay.setMap(null);
                    currentOverlayRef.current = null;
                    return;
                }

                // ✅ 기존 CustomOverlay 닫기
                if (currentOverlayRef.current) {
                    currentOverlayRef.current.setMap(null);
                }









                overlay.setMap(map);
                currentOverlayRef.current = overlay;
            });

            return marker;
        });

        // ✅ 새로운 마커 배열 저장
        setMarkers(newMarkers);

        // ✅ 지도 줌 최적화
        if (locations.length === 1 && singleLocation) {
            map.setCenter(singleLocation);
            map.setLevel(2);
        } else if (locations.length > 1) {
            map.setBounds(bounds);
        }
    }, [locations, map]); // ✅ locations 변경될 때 실행
*/


    useEffect(() => {
        if (!map) return;

        const handleZoomChanged = () => {
            const currentZoom = map.getLevel();
            setZoomLevel(currentZoom); // 지도 레벨을 슬라이드 값으로 동기화
        };

        // 지도 zoom_changed 이벤트 리스너
        window.kakao.maps.event.addListener(map, 'zoom_changed', handleZoomChanged);

        // 초기 렌더링 시 슬라이드 값 동기화
        setZoomLevel(map.getLevel());

        // 지도 타입을 변경하는 함수
        const changeMapType = (type) => {
            setMapType(type);
            switch (type) {
                case "ROADMAP":
                    map.setMapTypeId(window.kakao.maps.MapTypeId.ROADMAP); // 일반 지도
                    break;
                case "SKYVIEW":
                    map.setMapTypeId(window.kakao.maps.MapTypeId.SKYVIEW); // 위성 지도
                    break;
                case "HYBRID":
                    map.setMapTypeId(window.kakao.maps.MapTypeId.HYBRID); // 하이브리드 지도
                    break;
                default:
                    map.setMapTypeId(window.kakao.maps.MapTypeId.HYBRID);
            }
        };

        // 페이지 로드 후, 지도 초기화
        if (map) {
            changeMapType(mapType);
        }

    }, [mapType, map]);

    

    // 파트너 코드 리스트 가져오기
    const getPartnerCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Partner/get-list`);
            const data = await response.json();

            if (response.ok) {
                setPlist(data.plist);
                //console.log(data.plist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("파트너 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    // 파트너 코드 리스트 가져오기
    const getGovernmentCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Government/get-list`);
            const data = await response.json();

            if (response.ok) {
                setGlist(data.glist);
                //console.log(data.glist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("관공서 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    const handleSearchFieldChange = (e) => {
        //const selectedValue = e.target.value;
        setSearchField(e.target.value);  // 선택된 콤보박스 값 설정        
    };

    const handleSearchKeywordChange = (e) => {
        //const selectedValue = e.target.value;
        setSearchKeyword(e.target.value);  // 선택된 콤보박스 값 설정        
    };
    const handleSearchKeywordChange2 = (e) => {
        //const selectedValue = e.target.value;
        setSearchKeyword2(e.target.value);  // 선택된 콤보박스 값 설정        
    };

    const handleSearch = () => {
        fetchLocation(searchField, searchKeyword, searchKeyword2);  // 필터링된 값으로 다시 fetch 호출            
    };

    // 기존의 fetchUsers 함수에 검색 필터 추가
    const fetchLocation = async (searchField, searchKeyword, searchKeyword2) => {
        try {
            // searchField가 빈 문자열이면 null로 처리
            const queryParams = new URLSearchParams({
                searchField: searchField === "" ? "none" : searchField,
                searchKeyword: searchKeyword === "" ? "n" : searchKeyword,
                searchKeyword2: searchKeyword2 === "" ? "n" : searchKeyword2,
                governmentCode: user.governmentCode === "" ? "n" : user.governmentCode,
                ...(user.userType ? { loginUserType: user.userType } : {})
            });

            const response = await fetch(`${API_BASE_URL}/api/Enshrine/get-location?${queryParams}`);
            const data = await response.json();

            if (response.ok) {                
                //console.log(data.users);
                //console.log(data.totalRecords);
                setLocations(data.users);
                setTotnumber(data.totalRecords);
            } else {
                alert(data.message || "조회 실패");
            }
        } catch (error) {
            console.error("조회 실패:", error);
            alert("서버 오류 발생");
        }
    };

    const [selectedMapType, setSelectedMapType] = useState("ROADMAP");

    const handleMapChange = (event) => {
        setSelectedMapType(event.target.value);
        setMapType(event.target.value);
    };

    return (
        <div className="kmap-container">
            {/* 검색 섹션 */}

            {/* 카카오맵 */}
            <div id="kmap">

            <div className="mapsearch-container">

                {(user.userType === "S" || user.userType === "G" ) && (                
                    <label>
                        <select name="partnercode" value={searchField} onChange={handleSearchFieldChange}>
                            
                            <option value="ALL">전체파트너 보기</option> {/* 기본값 */}
                            
                            <option >------------------</option>
                            {user.userType === "S" && (
                                <>
                                {plist.map((partner) => (
                                    <option key={partner.snum} value={partner.partnerCode}>
                                        {/* {partner.snum}, {partner.partnerCode} - {partner.partnerName} */}
                                        {partner.partnerName} 
                                    </option>
                                ))}
                                </>
                            )}

                            {user.userType === "G" && (
                            <>
                                {plist
                                    .filter((partner) => partner.governmentCode === user.governmentCode) // 필터 적용
                                    .map((partner) => (
                                        <option key={partner.snum} value={partner.partnerCode}>
                                            {/* {partner.snum}, {partner.partnerCode} - {partner.partnerName} */}
                                            {partner.partnerName} 
                                        </option>
                                    ))
                                }
                            </>
                            )}

                            {user.userType === "S" && (
                                <>
                            <option >------------------</option>
                            {glist.map((government) => (
                                <option key={government.snum} value={government.governmentCode}>
                                    {/* {government.snum}, {government.governmentCode} - {government.governmentName} */}
                                    {government.governmentName}
                                </option>
                            ))}
                            </>

                            )}
                        <option >------------------</option>
                            <option value="">파트너 지정 없음</option> {/* 기본값 */}

                        </select>
                    </label>

                )}

                


            
                {/* "회원구분" 선택 시 새로운 콤보박스 출력 */}
                
                <label>
                    <select value={searchKeyword} onChange={handleSearchKeywordChange}>
                        <option value="">모든유형 보기</option> {/* 기본값 */}
                        <option value="CODE">봉안코드로 검색</option> {/* 기본값 */}
                        <option >------------------</option>
                                <option value="A">무연고묘 봉안</option>
                                <option value="B">무연고묘 확인</option>                                
                                <option value="D">연고자묘의 봉안</option>
                                <option value="E">연고자묘</option>
                    </select>
                </label>


                {/* 검색어 입력 (전체조회) */}
                {searchKeyword === "CODE" && (
                    <label>

                        <input
                            type="text"
                            value={searchKeyword2}
                            onChange={handleSearchKeywordChange2}
                            maxLength={18}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSearch(); // 
                                }
                            }}
                        />
                    </label>
                )}
                    

                <button onClick={handleSearch}>검색 {totnumber}</button>
                
                {/*<button onClick={() => setMapType("ROADMAP")}>A</button>
                <button onClick={() => setMapType("SKYVIEW")}>B</button>
                <button onClick={() => setMapType("HYBRID")}>C</button>
                */}  
            </div>



            
            
            <div className="map-type-selector">                

                <div className="zoom-controls">
                    <button onClick={handleZoomIn}>+</button>
                    <div className="zoom-slider-container">
                        <input
                            type="range"
                            min="0"
                            max="14"
                            value={14 - zoomLevel}
                            onChange={handleSliderChange}
                            className="zoom-slider"
                            step="1"
                        />
                    </div>
                    <button onClick={handleZoomOut}>-</button>
                </div>

                <div style={buttonStyle} onClick={handleCurrentLocation}></div>

                <input
                    type="radio"
                    id="roadmap"
                    name="mapType"
                    value="ROADMAP"
                    checked={selectedMapType === "ROADMAP"}
                    onChange={handleMapChange}
                />
                <label htmlFor="roadmap">Normal</label>

                <input
                    type="radio"
                    id="skyview"
                    name="mapType"
                    value="SKYVIEW"
                    checked={selectedMapType === "SKYVIEW"}
                    onChange={handleMapChange}
                />
                <label htmlFor="skyview">SKY</label>

                <input
                    type="radio"
                    id="hybrid"
                    name="mapType"
                    value="HYBRID"
                    checked={selectedMapType === "HYBRID"}
                    onChange={handleMapChange}
                />
                <label htmlFor="hybrid">HYBRID</label>
                
            </div>

            </div>
            
        </div>
    );

};

export default TombsMap;
